@if (isLoading) {
  <loader [config]="loaderConfig"></loader>
}

<div class="card company-document-view-card">
  <div class="card-header d-flex align-items-center gap-2">
    <h3 class="card-title mb-0">Company Document</h3>
    @if (code) {
      <span class="badge company-document-code-badge">{{ code }}</span>
    }
  </div>

  <div class="card-body">
    <company-documents-form
      [companyDocument]="companyDocument"
      [companyDocumentId]="companyDocumentId"
      [isEditPage]="true"
      [readonlyForm]="true">
      @if (companyDocument) {
        <div companyDocumentExtraInfo class="company-document-creator-info">
          <i class="fa fa-user-circle creator-icon"></i>
          <div>
            <div class="creator-label">Created by</div>
            <div class="creator-name">{{ creatorLabel }}</div>
            @if (createTimeLabel) {
              <div class="creator-meta">
                <i class="fa fa-calendar me-1"></i>{{ createTimeLabel }}
              </div>
            }
          </div>
        </div>
      }
    </company-documents-form>
  </div>

  @if (canModify) {
    <div class="card-footer">
      <div class="d-flex justify-content-center align-items-center gap-2 my-2">
        <button type="button" class="btn btn-primary" (click)="goToEdit()">Edit document</button>
      </div>
    </div>
  }
</div>

@if (companyDocumentId) {
  <div class="card company-document-revisions-card mt-3">
    <div class="card-header d-flex align-items-center">
      <h3 class="card-title mb-0">Revisions</h3>
      @if (canModify) {
        @if (revisionInProgressId) {
          <button type="button" class="btn btn-warning ms-auto" (click)="goToNewRevision()">
            <i class="fa fa-pencil me-1"></i>Open revision in progress
            @if (revisionInProgressCode) {
              <span class="ms-1">({{ revisionInProgressCode }})</span>
            }
          </button>
        } @else {
          <button type="button" class="btn btn-success ms-auto" (click)="goToNewRevision()">
            <i class="fa fa-plus me-1"></i>New revision
          </button>
        }
      }
    </div>
    <div class="card-body">
      <company-document-revisions
        [companyDocumentId]="companyDocumentId"
        [canDelete]="canDeleteRevision"
        (openRevision)="onOpenRevision($event)">
      </company-document-revisions>
    </div>
  </div>
}
